import React from 'react';
import Button from '@sizeid/commons/components/Button';
import { Icon } from '@sizeid/commons/components/SvgImage';
import { BUSINESS_INDEX } from '@sizeid/shared/constants/routes';

import app from 'components/app';
import Page from 'components/Page';
import Section from 'components/Page/Section';
import Wrapper from 'components/Page/Wrapper';
import H1 from 'components/typo/Heading/H1';
import H2 from 'components/typo/Heading/H2';
import P from 'components/typo/P';
import RouteLink from 'components/RouteLink';
import { createAnchor } from 'components/Navigation/utils';
import { handleScrollTo } from 'utils/scrollTo';
import { useTranslation } from 'lib/i18n';

import BusinessTopButtons from '../BusinessTopButtons';
import { BUSINESS_SIGN_IN, BUSINESS_SIGN_UP } from '../constants';

import OrganizationsPurpose from './OrganizationsPurpose';
import OrganizationsBenefits from './OrganizationsBenefits';
import OrganizationsContact from './OrganizationsContact';
import PriceList from './PriceList';
import Steps from './Steps';
import { DEMO_ANCHOR } from './constants';
import { jumbotron } from './styles';

const OrganizationsIndex: React.FC = () => {
  const { t, i18n } = useTranslation('pages');

  const lang = i18n.language;
  return (
    <Page
      title={t('business.organizations.index.title')}
      footer
      noPadding
      scrollingHeader
      hideMenu
    >
      <>
        <Section css={jumbotron} headerColor>
          <Wrapper>
            <>
              <RouteLink href={BUSINESS_INDEX.route}>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid*/}
                <a>
                  <span>
                    <Icon image="arrow" size="18px" />
                    {t('business.organizations.index.back')}
                  </span>
                </a>
              </RouteLink>
              <H1 css="padding-top: 0 !important;">
                {t('business.organizations.index.h1')}
              </H1>
              <P>{t('business.organizations.index.description')}</P>
              <BusinessTopButtons>
                <Button
                  link={createAnchor(DEMO_ANCHOR)}
                  onClick={handleScrollTo()}
                  giant
                  danger
                >
                  {t('business.organizations.index.function')}
                </Button>
                <Button link={BUSINESS_SIGN_UP(lang)} giant>
                  {t('business.index.createAccount')}
                </Button>
                <Button link={BUSINESS_SIGN_IN(lang)} giant outline white>
                  {t('business.index.login')}
                </Button>
              </BusinessTopButtons>
            </>
          </Wrapper>
        </Section>
        <Section white topWave beforeWave>
          <Wrapper>
            <Steps />
            <H2>{t('business.organizations.index.benefits.title')}</H2>
            <P bigOnDesktop>
              {t('business.organizations.index.benefits.description')}
            </P>
            <OrganizationsBenefits />
          </Wrapper>
        </Section>
        <Section beforeWave topWave gray>
          <Wrapper>
            <>
              <H2>{t('business.organizations.index.purpose.title')}</H2>
              <P bigOnDesktop>
                {t('business.organizations.index.purpose.description')}
              </P>
              <OrganizationsPurpose />
            </>
          </Wrapper>
        </Section>
        <Section beforeWave topWave white id={DEMO_ANCHOR}>
          <Wrapper>
            <>
              <H2>{t('business.organizations.index.demo.title')}</H2>
              <P bigOnDesktop>
                {t('business.organizations.index.demo.description')}
              </P>
              <OrganizationsContact />
            </>
          </Wrapper>
        </Section>
        <Section topWave gray>
          <Wrapper>
            <>
              <H2>{t('business.organizations.index.pricing.title')}</H2>
              <P bigOnDesktop>
                {t('business.organizations.index.pricing.description')}
              </P>
              <PriceList />
            </>
          </Wrapper>
        </Section>
      </>
    </Page>
  );
};

export default app(OrganizationsIndex, {
  theme: 'business',
});
